import dayjs from "dayjs";

const convertDate = (date) =>
  Boolean(date) ? dayjs(date).format("DD-MM-YYYY HH:mm") : "-";

export default convertDate;
